/* eslint-disable no-param-reassign */

function findFirstMatchingConfig(link, configs) {
  let i; let config;
  const href = link.attrs[link.attrIndex('href')][1];

  for (i = 0; i < configs.length; ++i) {
    config = configs[i];

    // if there is no pattern, config matches for all links
    // otherwise, only return config if href matches the pattern set
    if (!config.pattern || new RegExp(config.pattern).test(href)) {
      return config;
    }
  }
}

function applyAttributes(idx: any, tokens, attributes) {
  Object.keys(attributes).forEach((attr) => {
    const value = attributes[attr];

    if (attr === 'className') {
      attr = 'class';
    }

    const attrIndex = tokens[idx].attrIndex(attr);

    if (attrIndex < 0) { // attr doesn't exist, add new attribute
      tokens[idx].attrPush([attr, value]);
    } else { // attr already exists, overwrite it
      tokens[idx].attrs[attrIndex][1] = value; // replace value of existing attr
    }
  });
}

export default function markdownitLinkAttributes(md, configs) {
  if (!configs) {
    configs = [];
  } else {
    configs = Array.isArray(configs) ? configs : [configs];
  }

  Object.freeze(configs);

  const defaultRender = md.renderer.rules.link_open || function (tokens, idx, options, env, self) {
    return self.renderToken(tokens, idx, options);
  };

  md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
    const config = findFirstMatchingConfig(tokens[idx], configs);
    const attributes = config?.attrs;

    if (attributes) {
      applyAttributes(idx, tokens, attributes);
    }

    return defaultRender(tokens, idx, options, env, self);
  };
}
